module.exports = __webpack_public_path__ + "static/img/MARCUS-KRASNADAMSKIS.62f2b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MARCUS-KRASNADAMSKIS.jpg
// module id = 7iX5
// module chunks = 0